"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var color_1 = require("@seaweb/coral/utils/color");
var SkippableRegion_1 = __importDefault(require("./SkippableRegion"));
var SidebarContainer = styled_1.default(SkippableRegion_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 260px;\n  flex-shrink: 0;\n  border-right-width: 1px;\n  border-right-style: solid;\n  box-sizing: border-box;\n  overflow-y: auto;\n\n  ", "\n"], ["\n  width: 260px;\n  flex-shrink: 0;\n  border-right-width: 1px;\n  border-right-style: solid;\n  box-sizing: border-box;\n  overflow-y: auto;\n\n  ",
    "\n"])), function (_a) {
    var _b = _a.theme, colors = _b.colors, spacing = _b.spacing;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-color: ", ";\n    background-color: ", ";\n    padding: ", "px 0;\n  "], ["\n    border-color: ", ";\n    background-color: ", ";\n    padding: ", "px 0;\n  "])), colors.border, color_1.alp(colors.fade, 0.2), spacing.factor * 3);
});
var Sidebar = react_1.forwardRef(function Sidebar(_a, ref) {
    var _b = _a.as, as = _b === void 0 ? 'aside' : _b, _c = _a.skipNavable, skipNavable = _c === void 0 ? true : _c, props = __rest(_a, ["as", "skipNavable"]);
    return (react_1.default.createElement(SidebarContainer, __assign({ _as: as, ref: ref, name: "1-sidebar", label: "Skip to sidebar", disabled: !skipNavable }, props)));
});
exports.default = Sidebar;
var templateObject_1, templateObject_2;
